import React from 'react'
import { SearchConsoleIntervals } from 'utils/Enum'

import './intervalSelector.scss'

const IntervalSelector = ({ value, onChange }) => (
  <div className="intervalSelector">
    {Object.keys(SearchConsoleIntervals).map(key => (
      <div
        key={`interval-${key}`}
        className={`intervalSelector__item ${key === value ? 'active' : ''}`}
        onClick={() => onChange(key)}
      >
        {SearchConsoleIntervals[key].label}
      </div>
    ))}
  </div>
)

export default IntervalSelector



// WEBPACK FOOTER //
// ./app/components/search_console/partials/IntervalSelector.js